export default __webpack_public_path__ + "static/media/IMG_8323.be1e99f9.jpg";